export default __webpack_public_path__ + "static/media/ic_liquidity.505b3f30.svg";